import { UID, getColumns } from "./common";

export default {
  columns: getColumns({
    header: "Branding",
    subheader:
      "Control the appearance of your payment link and its social preview metadata."
  }),
  rows: [
    {
      title: {
        value: "Custom subdomain",
        tooltip:
          "Your domain is available on the link (i.e yourdomain.priceblocs.com)."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Custom metadata",
        tooltip: "Edit the metadata for any of your links."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Custom alias",
        tooltip: "Add a custom alias for any of your links."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true,
        value: "Coming soon"
      }
    }
  ]
};
